import { axiosInstanceToken } from "./interceptor/interceptor";

// Función GET
export const getRequest = async (source) => {
  try {
    const response = await axiosInstanceToken.get(source); 
    return response.data; // Retorna solo los datos
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Función POST
export const postRequest = async (url, data, config = {}) => {
  try {
    const response = await axiosInstanceToken.post(url, data, config); // Usamos la instancia con el token
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Función PUT
export const putRequest = async (source, data) => {
  try {
    const response = await axiosInstanceToken.put(source, data); // Usamos la instancia con el token
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Función DELETE
export const deleteRequest = async (source,data) => {
  try {
    const response = await axiosInstanceToken.delete(source,data); // Usamos la instancia con el token
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Función para realizar múltiples solicitudes de forma simultánea
export const promiseAllRequest = async (sources) => {
  const dataArr = sources.map(source => axiosInstanceToken.get(source));
  try {
    const result = await Promise.all(dataArr);
    return result.map(response => response.data);
  } catch (error) {
    console.error('Error en la ejecución de múltiples solicitudes', error);
    throw error;
  }
};
